import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To124(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectRatio1To124"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 4.5H5A1.5 1.5 0 0 0 3.5 6v12A1.5 1.5 0 0 0 5 19.5h3A1.5 1.5 0 0 0 9.5 18V6A1.5 1.5 0 0 0 8 4.5M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm8.488 2.75a.75.75 0 0 1 .75-.75h7.015a.75.75 0 0 1 0 1.5h-7.015a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h7.015a.75.75 0 0 0 0-1.5zm-.75-2.25a.75.75 0 0 1 .75-.75h4.015a.75.75 0 0 1 0 1.5h-4.015a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h4.015a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To124);
